import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import RefRoute from "./RefRoute";
import RoutesNew from "./Routes";
import {
  selectRefCode,
  setReferral,
} from "../redux/slices/referralSlice.slice";
import { useEffect, useState } from "react";

const RootGate = () => {
  const [searchParams] = useSearchParams();
  const refCode = useSelector(selectRefCode);
  const [valid, setvalid] = useState();

  const url = useLocation()?.pathname || {};

  const refInUrl = new URLSearchParams(window.location.search).get("ref");

  if (refInUrl || refCode) {
    return <RefRoute />;
  }

  return <RoutesNew />;
};

export default RootGate;
